<!--
    项目团队  lc
 -->
<template>
    <div class="project-team-page">
        <div :class="['header_back']">
            <div v-if="bBack" class="back_icon" @click.stop="goback">
                <span></span>
            </div>
            {{$route.meta.title}}
        </div>
        <div class="back_warp">
            <div class="personnel-info">人员信息</div>
            <div class="person-box">
                <div v-for="(item,index) in dataList">
                    <div class="businessCard"
                        :style="{borderRadius: item.certification.length > 0 ? '24px 24px 0 0' : '24px'}">
                        <div class="person-image"><img :src="item.icon" /></div>
                        <div class="person-info">
                            <div class="position-workCard">
                                <div class="position">{{item.rel_group_name}}</div>
                                <div class="workCard" v-if="item.job_number.length != ''">工牌：{{item.job_number}}</div>
                            </div>
                            <div class="center-box">
                                <div>
                                    <div class="name">{{item.name}}</div>
                                    <!--                                <div class="score">
                                        <div class="score-img">
                                            <van-rate v-model="item.score_rang" :size="12" allow-half readonly
                                                color="#FCBF82" void-icon="star" void-color="#eee" />
                                        </div>
                                        <div class="score-name">{{item.score_rang}}分</div>
                                    </div> -->
                                </div>
                                <div class="phone-icon" @click="changeIsPopup(item)" v-if="item.qr_code != ''">
                                    <img :src="require('@/assets/images/project/ewm-icon.png')" />
                                </div>
                            </div>
                            <div class="duty">岗位职责：{{item.desc}}</div>
                        </div>
                    </div>
                    <div class="qualif-box" v-if="item.certification.length > 0">
                        <div v-for="(item,index) in item.certification" class="tick-box">
                            <div class="tick-icon"><img :src="require('@/assets/images/project/Tick-icon.png')" /></div>
                            <div class="tick-name">{{item.name}}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="home_icon" @click="getHome" :style="{bottom: showInfo == 2 ? '108px':'88px'}">
                <img src="@/assets/images/member/v2/plan/home_icon.png" />
            </div>


            <div class="entity-wrap" v-if="false">
                <!--    服务标签    -->
                <div class="service-tags-content">
                    <div class="tags-title">厂家直控层层把关省心、可靠</div>
                    <!--      标签内容      -->
                    <div class="tags-content">
                        <div v-for="tag in arrServiceTags" :key="tag.name" class="tags-item">
                            <img class="tag-icon" :src="require('@/assets/images/user/house/project-team-finish-icon.png')"
                                alt="" />
                            <p class="tag-text">{{ tag.name }}</p>
                        </div>
                    </div>
                </div>
                <div class="banner-image">
                    <img v-lazy="require('@/assets/images/project-detail/0005-test.png')" alt="">
                </div>
                <!--    人员    -->
                <template v-if="dataList.length > 0">
                    <div v-for="(item, index) in dataList" :key="index" class="person-item-content">
                        <div class="person-top">
                            <div class="person-infi-left">
                                <div class="head-img">
                                    <img v-lazy="item.icon" class="head-image" />
                                </div>
                                <div class="info">
                                    <div style="display: flex;align-items: center;">
                                        <div class="name">{{ item.name }}</div>
                                        <div class="jobNumber">{{ item.job_number }}</div>
                                    </div>
                                    <!-- <div class="start">
                                        <img :src="require('@/assets/images/team/start-active.png')" class="head-image" v-for="item in item.score_rang" :key="item" />
                                        <span>{{ item.score_rang }}分</span>
                                    </div> -->
                                </div>
                            </div>
                            <div class="person-infi-right">
                                <a :href="'tel:' + item.phone">
                                    <img :src="require('@/assets/images/team/working_icon.png')" class="head-image" />
                                </a>
                            </div>
                            <!-- 身份 -->
                            <div class="card">{{ item.rel_group_name }}</div>
                        </div>
                        <div v-if="item.certification.length > 0" class="person-bottom">
                            <div v-for="(item1, index1) in item.certification" :key="index1" class="per-img">
                                <img :src="item1.icon" alt="">
                                <span>{{ item1.name }}</span>
                            </div>
                        </div>
                    </div>
                </template>

                <!--        头像        -->
            </div>
            <popup :nTitle="arrMent.name" :nEwmImg="arrMent.qr_code" :nPopup.sync="isPopup"></popup>
            <share :isFixed="true" v-if="showInfo == 2"></share>
        </div>
    </div>

</template>

<script>
    import popup from '../components/qrcode.vue';
    import {
        Image
    } from "vant";
    import {
        getProectList,
        getTeamV2
    } from '@/js/house/appindex.js';
    let matched = [];
    export default {
        name: "project-team",
        components: {
            VantImage: Image,
            popup,
        },
        data() {
            return {
                bBack: matched.length,
                // 标签渲染数组
                arrServiceTags: [{
                        name: "上门设计",
                    },
                    {
                        name: "专属定制",
                    },

                    {
                        name: "一站式售后",
                    },
                    {
                        name: "三维实景方案",
                    },
                    {
                        name: "施工全流程在线交付",
                    },
                    {
                        name: "实时在线监管",
                    },
                ],
                dataList: [], // 负责人列表
                imgUrl: {},
                arrPerson: [{
                        icon: 'https://s1.ax1x.com/2022/07/25/jv4L6O.jpg',
                        rel_group_name: '项目经理',
                        name: '老刘',
                        job_number: '55648888',
                        certification: [],
                        score_rang: 4.8,
                        desc: '岗位职责：调配能工人员，监督施工进度',
                        counEwm: require('/src/assets/images/user/housev2/qrcode_demo.png'),
                    },
                    {
                        icon: 'https://s1.ax1x.com/2022/07/25/jv4L6O.jpg',
                        rel_group_name: '项目经理',
                        name: '老刘',
                        job_number: '55648888',
                        score_rang: 3.6,
                        desc: '岗位职责：调配能工人员，监督施工进度',
                        certification: [{
                            name: '项目经理'
                        }, {
                            name: '调配能工'
                        }, {
                            name: '监督施工'
                        }, {
                            name: '项目'
                        }, {
                            name: '调配能工'
                        }, {
                            name: '监督施工'
                        }, {
                            name: '项目经理'
                        }, {
                            name: '调配能工'
                        }, {
                            name: '监督施工'
                        }, {
                            name: '项目'
                        }, {
                            name: '调配能工'
                        }, {
                            name: '监督施工'
                        }],
                        counEwm: require('/src/assets/images/user/housev2/qrcode_demo.png'),
                    }
                ],
                isPopup: false,
                counName: '',
                counEwm: '',
                reate: 2.5,
                arrMent: {},
                project: '',
                showInfo: false,
            };
        },
        created() {
            this.getTeamData()
        },
        computed: {
            setTile() {
                return function(value) {
                    if (value == "project_manager") return "项目经理";
                    if (value == "project_supervisor") return "监理";
                    if (value == "project_salesperson") return "签单手";
                    if (value == "project_designer") return "设计者";
                    if (value == "project_responsible_person") return "施工人员";
                };
            },
            getData() {
                getProectList(
                    { user_id: this.$storage.getStorage('app_user_id'),app:1 }
                ).then((res) => {
                    console.log(res)
                })
            },
        },
        beforeRouteEnter(to,from,next){
            matched = from.matched;
            next();
        },
        methods: {
            goback(){
                this.$router.go(-1);
            }, 
            addCount(params) {
                this.isPopup = false
            },
            getTeamData() {
                const new_srv_projectmgnid = this.$route.query.project;
                this.$store.commit("loadSkeleton", {
                    bool: true,
                    type: "team"
                }); // 页面loading开启
                getTeamV2({
                    app: 1,
                    projectmgnid: new_srv_projectmgnid,
                    user_id: this.$storage.getStorage('app_user_id'),
                }).then(res => {
                    this.$store.commit("loadSkeleton", {
                        bool: false,
                        type: "team",
                    }); // 页面loading开启
                    let objData = res.data.data.result.team
                    for (let i in objData) {
                        if (objData[i].length != 0) {
                            this.dataList.push({
                                i,
                                ...objData[i]
                            })
                        }
                    }
                    console.log(this.dataList, 'this.dataList');
                })
            },
            getHome() {
                let Object = this.$storage.getStorage('sampleroom_info');
                this.$router.push({
                    path: `/member/v3/index/index?appmob=${this.$storage.getStorage('app_mob')}`,
                });
            },
            changeIsPopup(item) {
                this.arrMent = item
                this.isPopup = true
            }
        }
    };
</script>

<style scoped lang="scss">
    .project-team-page {
        padding-left: env(safe-area-inset-left);
        padding-right: env(safe-area-inset-right);
        padding-bottom: env(safe-area-inset-bottom);
        .header_back{
            background: #FFF;
            padding-top: 60px;
            box-sizing: border-box;
            height: 180px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 30px;
            position: relative;
            .back_icon{
                position: absolute;
                left: 50px;
                width: 100px;
                height: 100px;
                display: flex;
                align-items: center;
                span{
                    display: block;
                    width: 18px;
                    height: 18px;
                    border: 3px solid #000;
                    border-right: 0;
                    border-bottom: 0;
                    transform: rotate(-45deg);
                }
            }
        }
        .back_warp{
            height: calc(100vh - env(safe-area-inset-bottom) - 180px);
            overflow-x: hidden;
            overflow-y: scroll;
            padding-top: 48px;
            box-sizing: border-box;
            background: #7AA894;
        }
        

        .personnel-info {
            font-size: 32px;
            color: #FFFFFF;
            margin: 0 32px 48px;
        }

        .person-box {
            width: 750px;
            height: calc(100vh - 260px);
            overflow-x: hidden;
            overflow-y: scroll;
            background: #F9F9F9;
            border-radius: 24px 24px 0 0;
            padding: 16px 0 32px 0;

            .businessCard {
                width: 686px;
                background: #FFFFFF;
                // border-radius: 24px;
                margin: 0 auto;
                padding: 48px 48px 48px 32px;
                display: flex;
                margin-top: 16px;

                .person-image {
                    img {
                        width: 132px;
                        height: 132px;
                        border-radius: 50%;
                        border: 1px solid #DDDDDD;
                    }
                }

                .person-info {
                    margin-left: 34px;

                    .position-workCard {
                        display: flex;

                        .position {
                            font-size: 20px;
                            font-weight: 400;
                            color: #999999;
                        }

                        .workCard {
                            margin-left: 32px;
                            font-size: 20px;
                            font-weight: 400;
                            color: #999999;
                            line-height: 30px;
                        }
                    }

                    .center-box {
                        display: flex;
                        justify-content: space-between;

                        .name {
                            font-size: 32px;
                            font-weight: 500;
                            color: #3D3C4F;
                            line-height: 48px;
                            margin: 8px 0;
                        }

                        .score {

                            display: flex;

                            .score-img {
                                margin-top: 8px;
                                display: flex;

                                img {
                                    width: 24px;
                                    height: 24px;
                                }
                            }

                            .score-name {
                                font-size: 24px;
                                font-weight: 400;
                                color: #9D9D9D;
                                margin-left: 18px;
                            }


                        }

                        .phone-icon {
                            img {
                                width: 64px;
                                height: 64px;
                            }
                        }
                    }

                    .duty {
                        width: 440px;
                        padding-top: 22px;
                        border-top: 1px solid #DDDDDD;
                        font-size: 20px;
                        font-weight: 400;
                        color: #999999;
                        line-height: 30px;
                        margin-top: 34px;
                    }
                }
            }

            .qualif-box {
                width: 686px;
                // height: 88px;
                background: rgba(53, 93, 75, 0.1);
                border-radius: 0px 0px 24px 24px;
                display: flex;
                margin: 0 auto;
                padding: 32px 40px;
                flex-wrap: wrap;

                .tick-box {
                    display: flex;
                    margin-bottom: 12px;
                    // flex-wrap: nowrap;

                    .tick-icon {
                        margin-top: 2px;

                        img {
                            width: 24px;
                            height: 24px;
                        }
                    }

                    .tick-name {
                        font-size: 20px;
                        color: #355D4B;
                        margin-left: 16px;
                        margin-right: 40px;
                    }
                }
            }
        }

        .home_icon {
            position: fixed;
            right: 4px;

            img {
                width: 112px;
                height: 112px;
            }
        }





        .banner-image {
            width: 100%;
            // height: 366px;
            background: #ededed;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 32px;
            color: #222222;
        }

        .entity-wrap {
            padding: 28px 24px 18px;

            .service-tags-content {
                height: 314px;
                padding: 24px 24px 36px;
                border-radius: $commonRadius;
                margin-bottom: 24px;
                background: #ffffff;

                .tags-title {
                    color: $deepGreen;
                    font-size: $bigSize;
                    display: flex;
                    align-items: center;
                    line-height: 44px;
                    margin-bottom: 18px;
                    font-weight: 500;

                    &::before {
                        content: "";
                        margin-right: 12px;
                        display: block;
                        width: 6px;
                        height: 32px;
                        background: $defaultGreen;
                    }
                }

                .tags-content {
                    display: flex;
                    flex-wrap: wrap;
                    justify-content: space-between;
                    padding-left: 16px;

                    .tags-item {
                        flex: 0 0 40%;
                        margin-top: 24px;
                        display: flex;
                        align-items: center;
                        height: 40px;
                        line-height: 40px;

                        &:nth-child(odd) {
                            flex: 0 0 60%;
                        }

                        .tag-icon {
                            width: 36px;
                            height: 36px;
                            margin-right: 12px;
                        }

                        .tag-text {
                            font-size: $baseSize;
                        }
                    }
                }
            }

            .person-item-content {
                margin-top: 32px;
                width: 100%;

                .person-top {
                    width: 100%;
                    height: 172px;
                    background: linear-gradient(135deg, #61ba79 0%, #328444 100%);
                    box-shadow: 0px 0px 12px 0px rgba(50, 132, 68, 0.16);
                    border-radius: 12px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding: 0 36px 0 28px;
                    position: relative;

                    .person-infi-left {
                        display: flex;
                        align-items: center;

                        .head-img {
                            img {
                                width: 88px;
                                height: 88px;
                                border-radius: 50%;
                            }
                        }

                        .info {
                            padding-left: 20px;

                            .name {
                                font-size: 32px;
                                font-weight: 500;
                                color: #ffffff;
                            }

                            .jobNumber {
                                font-size: 28px;
                                color: #DBECDF;
                                font-weight: 400;
                                margin-left: 20px;
                            }

                            .start {
                                margin-top: 10px;
                                display: flex;
                                align-items: center;

                                img {
                                    width: 28px;
                                    height: 28px;
                                    vertical-align: middle;
                                }

                                span {
                                    font-size: 24px;
                                    font-weight: 400;
                                    color: #ffcb03;
                                    padding-left: 16px;
                                }
                            }
                        }
                    }

                    .person-infi-right {
                        margin-top: 24px;

                        img {
                            width: 76px;
                            height: 76px;

                        }
                    }

                    .card {
                        width: 148px;
                        height: 48px;
                        background: url(~@/assets/images/team/title_bg.png) no-repeat center/cover;
                        position: absolute;
                        top: 0;
                        right: 0;
                        font-weight: 400;
                        color: #ffffff;
                        text-align: center;
                        line-height: 48px;
                        letter-spacing: 2px;
                    }
                }

                .person-bottom {
                    background: #ffff;
                    padding: 20px 26px;
                    display: flex;
                    flex-wrap: wrap;

                    .per-img {
                        display: flex;
                        align-items: center;
                        margin-bottom: 36px;

                        img {
                            width: 68px;
                            height: 68px;
                            margin-right: 20px;
                        }

                        span {
                            font-size: 32px;
                            font-weight: 400;
                            color: #444444;

                            margin-right: 40px;
                        }
                    }

                    // div:nth-child(2n - 1){
                    //     border: 1px solid red;
                    //  // }
                }
            }
        }
    }
</style>
